module.exports = __webpack_public_path__ + "img/istockphoto-1091058068-612x612.68a1b2ec.jpg";